import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/formheader/formheaderview
 */
import View from '../view.js';
import IconView from '../icon/iconview.js';
import '../../theme/components/formheader/formheader.css';
/**
 * The class component representing a form header view. It should be used in more advanced forms to
 * describe the main purpose of the form.
 *
 * By default the component contains a bolded label view that has to be set. The label is usually a short (at most 3-word) string.
 * The component can also be extended by any other elements, like: icons, dropdowns, etc.
 *
 * It is used i.a.
 * by {@link module:table/tablecellproperties/ui/tablecellpropertiesview~TableCellPropertiesView}
 * and {@link module:special-characters/ui/specialcharactersnavigationview~SpecialCharactersNavigationView}.
 *
 * The latter is an example, where the component has been extended by {@link module:ui/dropdown/dropdownview~DropdownView} view.
 */
var FormHeaderView = /*#__PURE__*/function (_View) {
  _inherits(FormHeaderView, _View);
  var _super = _createSuper(FormHeaderView);
  /**
   * Creates an instance of the form header class.
   *
   * @param locale The locale instance.
   * @param options.label A label.
   * @param options.class An additional class.
   */
  function FormHeaderView(locale) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, FormHeaderView);
    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    _this.set('label', options.label || '');
    _this.set('class', options.class || null);
    _this.children = _this.createCollection();
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-form__header', bind.to('class')]
      },
      children: _this.children
    });
    if (options.icon) {
      _this.iconView = new IconView();
      _this.iconView.content = options.icon;
      _this.children.add(_this.iconView);
    }
    var label = new View(locale);
    label.setTemplate({
      tag: 'h2',
      attributes: {
        class: ['ck', 'ck-form__header__label']
      },
      children: [{
        text: bind.to('label')
      }]
    });
    _this.children.add(label);
    return _this;
  }
  return FormHeaderView;
}(View);
export { FormHeaderView as default };